module.exports = __webpack_public_path__ + "static/media/WARNING_RED.32b78af1.svg";